import * as React from 'react'

import { GatheringFields } from 'main/gql/gathering'
import { gatheringPath } from 'main/routes'
import { Calendar, NativeLink } from 'main/ui'
import { labelForGathering } from './util'

import { Container, Label, LabelContainer } from './GatheringBadge.styles'

interface IProps {
  gathering: GatheringFields
  showLabel: boolean
}

export default function GatheringBadge(props: IProps) {
  const { gathering, showLabel } = props
  const { beginsAt } = gathering

  const label = labelForGathering(gathering)

  return (
    <Container>
      <NativeLink href={gatheringPath(gathering)} target="_blank">
        <Calendar date={beginsAt} />
      </NativeLink>

      {showLabel && (
        <LabelContainer href={gatheringPath(gathering)} target="_blank">
          <Label>{label}</Label>
        </LabelContainer>
      )}
    </Container>
  )
}
